import type { StaticLayerPayload } from "@config";
import { ImageLibrary } from "@library-elements/image";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: ImageLibrary,
};

export const Image = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
